export default __webpack_public_path__ + "static/media/img-0371-ovato-nation-half-face.e080157b.png";